import { spacings } from "../../assets/themes";
import Block from "../Block";

const Footer = ({ children, className, style }) => (
  <Block marginTop={spacings.sm} style={style} className={className}>
    {children}
  </Block>
);
export default Footer;
